import React from 'react';

const SectionLabel = ({ children, testId }) => (
  <p
    data-testid={testId}
    className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-6"
  >
    <span className="label-divider" />
    {children}
  </p>
);

export default SectionLabel;
